import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Theme } from 'styles/Themes'

interface IMenuProps {
  extended: boolean
}

interface IButtonStyleProps {
  active?: boolean
  extended: boolean
  disabled?: boolean
  renderBorder?: boolean
}

interface ILogoutButtonStyleProps {
  active?: boolean
  extended: boolean
  logoutButton?: boolean
}

export const Menu = styled.div`
  transition: width 1s;
  z-index: 0;
  width: ${(props: IMenuProps) => {
    return `${props.extended ? '254px' : '75px'}`
  }};
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  z-index: 99;
  white-space: nowrap;
  background: ${Theme.pallete.PRIMARY};
  .logo-container {
    max-width: 100%;
    overflow: hidden;
  }
  .logo {
    overflow: hidden;
    max-height: 32px;
    transition: 1s;
    margin: ${(props: IButtonStyleProps) => {
      if (props.extended) return `14px 0px 14px 24px`
      return `14px 0px 14px 24px`
    }};
    display: flex;
  }
  .extendButton {
    width: 24px;
    height: 24px;
    transition: transform 1s;
    transform: rotate(180deg);
    background-color: ${({ theme }) => theme.filters.pageBg};
    border-radius: 50%;
    transform: ${(props: IMenuProps) => props.extended && 'none'};
    z-index: 99;
    position: absolute;
    right: -12px;
    top: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    outline: none;
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.4);
  }
  .icon {
    max-width: 14px;
    max-height: 14px;
  }
`

export const MenuButton = styled(Link)`
  display: flex;
  justify-content: flex-start;
  transition: width 1s;
  cursor: pointer;
  height: 60px;
  font-family: ${Theme.fontFamily.PRIMARY};
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.13px;
  color: ${(props: IButtonStyleProps) => {
    if (props.active) return `${Theme.pallete.SECONDARY}`
    return `${Theme.pallete.QUATERNARY}`
  }};
  background: ${(props: IButtonStyleProps & { theme: any }) => {
    return props.active
      ? props.theme.colors.greetingName
      : Theme.pallete.PRIMARY
  }};
  border-bottom: 1px solid rgba(66, 66, 66, 0.3);
  border-top: ${(props: IButtonStyleProps) => {
    return `${props.renderBorder ? `1px solid rgba(66, 66, 66, 0.3)` : '0'}`
  }};
  overflow: hidden;
  width: ${(props: IButtonStyleProps) => (props.extended ? '254px' : '75px')};
  &:hover {
    background: ${(props: IButtonStyleProps & { theme: any }) => {
      return props.active
        ? props.theme.colors.greetingName
        : Theme.pallete.PRIMARY
    }};
    color: ${Theme.pallete.SECONDARY};
    img {
      filter: ${Theme.icons.TERTIARY};
    }
  }
  img {
    margin: 20px 0px 0px 30px;
    max-width: 16px;
    max-height: 20px;
    filter: ${(props: IButtonStyleProps) => {
      if (props.active) return `${Theme.icons.TERTIARY}`
      return `${Theme.icons.PRIMARY}`
    }};
  }
  span {
    transition: width 1s, opacity 1s;
    opacity: ${(props: ILogoutButtonStyleProps) =>
      props.extended ? '1' : '0'};
    width: ${(props: IButtonStyleProps) => (props.extended ? '159px' : '0px')};
    margin: 22px 0px 0px 20px;
  }
`

export const FakeMenuButton = styled.div`
  display: flex;
  justify-content: flex-start;
  transition: width 1s;
  cursor: default;
  height: 60px;
  font-family: ${Theme.fontFamily.PRIMARY};
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.13px;
  color: ${Theme.pallete.PRIMARY4};
  background: ${(props: IButtonStyleProps) => {
    if (props.active) return `${Theme.pallete.TERTIARY}`
    return `${Theme.pallete.PRIMARY}`
  }};
  border-bottom: 1px solid rgba(66, 66, 66, 0.3);
  border-top: ${(props: IButtonStyleProps) => {
    return `${props.renderBorder ? `1px solid rgba(66, 66, 66, 0.3)` : '0'}`
  }};
  overflow: hidden;
  width: ${(props: IButtonStyleProps) => (props.extended ? '254px' : '75px')};

  img {
    margin: 20px 0px 0px 30px;
    max-width: 16px;
    max-height: 20px;
    filter: ${Theme.icons.TERTIARY2};
  }
  span {
    transition: width 1s, opacity 1s;
    opacity: ${(props: ILogoutButtonStyleProps) =>
      props.extended ? '1' : '0'};
    width: ${(props: IButtonStyleProps) => (props.extended ? '159px' : '0px')};
    margin: 22px 0px 0px 20px;
  }
`

export const LogoutButton = styled(Link)`
  display: flex;
  justify-content: center;
  transition: width 1s;
  cursor: pointer;
  height: 60px;
  font-family: ${Theme.fontFamily.PRIMARY};
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  letter-spacing: 0.13px;
  color: ${(props: ILogoutButtonStyleProps) => {
    if (props.active) return `${Theme.pallete.PRIMARY}`
    return `${Theme.pallete.QUATERNARY}`
  }};
  background: ${(props: ILogoutButtonStyleProps) => {
    if (props.active) return `${Theme.pallete.TERTIARY}`
    return `${Theme.pallete.PRIMARY}`
  }};
  border: ${(props: ILogoutButtonStyleProps) => {
    if (props.extended) return ''
    return `1px solid rgba(66, 66, 66, 0.3)`
  }};
  border-right: 0;
  border-left: 0;
  overflow: hidden;
  width: ${(props: ILogoutButtonStyleProps) =>
    props.extended ? '254px' : '75px'};
  &:hover {
    background: ${(props: IButtonStyleProps) => {
      if (props.active) return `${Theme.pallete.TERTIARY}`
      return `${Theme.pallete.PRIMARY4}`
    }};
    color: ${Theme.pallete.SECONDARY};
    img {
      filter: ${Theme.icons.TERTIARY};
    }
  }
  img {
    margin: ${(props: ILogoutButtonStyleProps) =>
      props.extended ? '20px 0px 0px 10px' : '20px 35px 0px 10px'};
    max-width: 16px;
    max-height: 20px;
    filter: ${Theme.icons.TERTIARY};
  }
  span {
    transition: width 1s, margin 1s, opacity 1s;
    opacity: ${(props: ILogoutButtonStyleProps) =>
      props.extended ? '1' : '0'};
    text-align: right;
    width: ${(props: ILogoutButtonStyleProps) =>
      props.extended ? '45px' : '0px'};
    margin: ${(props: ILogoutButtonStyleProps) =>
      props.extended ? '22px 0px 0px 20px' : '22px 0px 0px 30px'};
  }
`
